import axios from 'axios';

const api = axios.create({
  
 //baseURL: 'http://192.168.10.8:8000', //pcwinwin local
  
    //baseURL: 'http://167.71.119.249/api',    //produccion cunado no tiene nombre de dominio
 baseURL: 'https://villademio.cloud/api', //usar pasubir
  headers: {
    'Content-Type': 'application/json',
  },
});

// Interceptor para añadir el token en cada solicitud
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Interceptor para manejar errores de respuesta
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      localStorage.removeItem('token');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default api;